import { defineStore } from 'pinia';
import { Buildings } from '~/utils/constants';
import { BuildingNotificationIcon } from '~/utils/constants/buildingsTypeIcons';

type TMessage = {
  id: number;
  topic: BuildingNotificationIcon;
  message: string;
  isShowing: boolean;
};

export const useBuildingsNotificationsStore = defineStore('buildings-notifications', {
  state: () => ({
    messages: {} as Record<Buildings, TMessage[]>
  })
});
